import AutoZoomManager from "./AutoZoomManager";
import ManualZoomGenerator from "./ManualZoomGenerator";

export default class ZoomManager {
    //Public:
    constructor(cParams) {
        this.saveParams(cParams);
        this.initOnZoomChangeFunctions();
        this.initStatesHistory();
    }

    compute() {
        this.createManualZoomFunction();
        this.createAutoZoomManager();
    }

    setCenter(center) {
        if (this.existsAutoZoom()) this._autoZoomManager.setCenter(center);
    }

    applyAutoFit(nodes) {
        const delayTime = this._autoFitSettings.delayTime;
        this.applyAutoFitWithDelay(nodes, delayTime);
    }

    applyInitialAutoFit(nodes) {
        const delayTime = this._autoFitSettings.initialDelayTime;
        this.applyAutoFitWithDelay(nodes, delayTime);
    }

    getManualZoomFunction() {
        return this._manualZoom;
    }

    addOnZoomChangeListener(func) {
        this._onZoomChangeFuncs.push(func);
    }

    //Protected:
    addStateToHistory(state) {
        this._statesHistory.unshift(state);
        if (this._statesHistory.length > 2) this._statesHistory.pop();
    }

    getPreviousZoomState() {
        let state0 = this._statesHistory[1];
        if (state0 === undefined) return this.getZoomState();
        return state0;
    }

    //Private:
    saveParams(cParams) {
        this._elementId = cParams.elementId;
        this._svg = cParams.svg;
        this._minZoomScale = cParams.minZoomScale;
        this._autoFitSettings = cParams.autoFitSettings;
    }

    createManualZoomFunction() {
        const cParams = {
            manager: this,
            elementId: this._elementId,
            svg: this._svg,
            minZoomScale: this._minZoomScale,
        };
        let manualZoomGen = new ManualZoomGenerator(cParams);
        let func = manualZoomGen.compute();
        this._manualZoom = func;
    }

    createAutoZoomManager() {
        let cParams = this._autoFitSettings;
        cParams.svg = this._svg;
        cParams.manager = this;
        cParams.elementId = this._elementId;
        let autoZoomManager = new AutoZoomManager(cParams);
        this._autoZoomManager = autoZoomManager;
    }

    applyAutoFitWithDelay(nodes, delayTime) {
        if (this.existsAutoZoom()) {
            let autoZoomManager = this._autoZoomManager;
            autoZoomManager.setTimeout(nodes, delayTime);
        }
    }

    initStatesHistory() {
        this._statesHistory = [];
        this.addStateToHistory();
    }

    initOnZoomChangeFunctions() {
        this._onZoomChangeFuncs = [];
    }

    existsAutoZoom() {
        if (this._autoZoomManager !== undefined) return true;
        else return false;
    }
}
